import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import styleConstants from "../../../../styleConstants";
import "./sector.scss";

const useStyles = makeStyles(theme => ({
  path: {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: styleConstants.colors.gray5,
    opacity: 0
  }
}));

const Path = props => {
  const classes = useStyles();

  return (
    <path
      id={props.id}
      d={props.d}
      className={classnames(
        classes.path,
        props.groups,
        props.groups.includes(props.current) ? "active" : undefined
      )}
    />
  );
};

Path.propTypes = {
  id: PropTypes.string,
  d: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(PropTypes.string)
};

export default Path;
